<template>
  <BaseSimpleModal :title="`${$t('pay_invoice_modal.invoice')} #${invoice.serial_id || invoice.invoice_number}`"
    :showFooter="false" :showHeader="true" @backdropClick="$emit('close')" style="height:fit-content;" showClose
    :fullHeight="false" @close="$emit('close')" modalClass="pay-invoice-modal">
    <div class="services-table">
      <div class="services-table-header qrw-label-md">
        <div class="services-table-column column-service">{{ $t('pay_invoice_modal.service') }}</div>
        <div class="services-table-column column-period">{{ $t('pay_invoice_modal.period') }}</div>
        <div class="services-table-column column-subscription">{{ $t('pay_invoice_modal.subscription') }}</div>
        <div class="services-table-column column-sum">{{ $t('pay_invoice_modal.sum') }}</div>
      </div>
      <div class="gap-row-zero qrw-label-md">
        <div class="services-table-row" v-for="(service, index) in invoice.services" :key="index">
          <div class="services-table-column column-service">
            {{ formatServiceName(service.name) }}
          </div>
          <div class="services-table-column column-period">{{ invoice.period_start | formatDate }} - {{
    invoice.period_end |
    formatDate }}</div>
          <div class="services-table-column column-subscription">{{ $t('pay_invoice_modal.' + invoice.periodicity) }}
          </div>
          <div class="services-table-column column-sum">$ {{ service.amount }}</div>
        </div>
      </div>
      <div class="services-table-total qrw-label-md">
        <div>{{ $t('pay_invoice_modal.total') }}:</div>
        <div class="bold">$ {{ invoice.total }}</div>
      </div>
    </div>
    <div class="pay-modal-actions">
      <div class="gap-column-zero payment-type-row">
        <div class="qrw-label-lg bold qrw-text-content-base-primary">
          {{ $t('pay_invoice_modal.payment_type') }}
        </div>
        <BaseSwitcherBar size="sm" v-model="paymentType" tabWidth="210px"
          style="background: var(--qrw-background-base-tertiary); border-radius: 10px; padding: 2px;" :tabs="[{
    text: $t('pay_invoice_modal.by_card'),
    value: 'card'
  }, {
    text: $t('pay_invoice_modal.by_bank'),
    value: 'bank_transfer'
  }]" />
      </div>
      <BaseDivider color="border-base-tertiary" />
      <template v-if="paymentType === 'card'">
        <div class="gap-column-sm">
          <div class="gap-row-1xs w-100">
            <div class="qrw-label-lg bold qrw-text-content-base-primary">
              {{ $t('pay_invoice_modal.auto_payment') }}
            </div>
            <div class="qrw-label-sm qrw-text-content-base-tertiary">
              {{ $t('pay_invoice_modal.ap_hint') }}
            </div>
          </div>
          <BaseBetaToggle v-model="autoPayment" size="xs" />
        </div>
        <BaseDivider color="border-base-tertiary" />
        <div class="pay-button-row">
          <a :href="invoicePaymentLink" style="display: contents;">
            <BasePushButton size="md" variant="fill" bgColor="background-success-default"
              textColor="content-base-inverse-primary">
              {{ $t('pay_invoice_modal.pay_now') }} $ {{ invoice.total }}
            </BasePushButton>
          </a>
        </div>
      </template>
      <template v-else>
        <div class="gap-row-xs">
          <div class="gap-row-1xs">
            <div class="qrw-label-sm bold qrw-text-content-base-tertiary">
              {{ $t('pay_invoice_modal.recipient') }}
            </div>
            <div class="qrw-label-md qrw-text-content-base-primary">
              ФОП Кошун Микола Мирославович
            </div>
          </div>
          <div class="gap-row-1xs">
            <div class="qrw-label-sm bold qrw-text-content-base-tertiary">
              EDRPOU
            </div>
            <div class="qrw-label-md qrw-text-content-base-primary">
              3614808772
            </div>
          </div>
          <div class="gap-row-1xs">
            <div class="qrw-label-sm bold qrw-text-content-base-tertiary">
              {{ $t('pay_invoice_modal.bank') }}
            </div>
            <div class="qrw-label-md qrw-text-content-base-primary">
              {{ $i18n.locale === 'uk' ? 'АТ УНІВЕРСАЛ БАНК' : 'UNIVERSAL BANK' }}
            </div>
          </div>
          <div class="gap-row-1xs">
            <div class="qrw-label-sm bold qrw-text-content-base-tertiary">
              IBAN
            </div>
            <div class="qrw-label-md qrw-text-content-base-primary">
              UA133220010000026000310008560
            </div>
          </div>
          <div class="gap-row-1xs">
            <div class="qrw-label-sm bold qrw-text-content-base-tertiary">
              {{ $t('pay_invoice_modal.payment_description') }}
            </div>
            <div class="qrw-label-md qrw-text-content-base-primary">
              {{ $t('pay_invoice_modal.description_ph') }} #{{ invoice.invoice_number }}
            </div>
          </div>
        </div>
        <BaseDivider color="border-base-tertiary" />
        <div class="gap-column-xs">
          <div class="qrw-paragraph-sm qrw-text-content-base-tertiary">
            {{ $t('pay_invoice_modal.warning') }}
          </div>
          <a :href="`/api/superbilling/invoices/download/${invoice._id}`" target="_blank" style="display: contents;">
            <BasePushButton size="md" variant="primary" bgColor="background-base-inverse-primary"
              textColor="content-base-inverse-primary" icon="download-cloud" iconPosition="right">
              {{ $t('pay_invoice_modal.invoice')}}
            </BasePushButton>
          </a>
        </div>
      </template>
    </div>
  </BaseSimpleModal>
</template>

<script>
export default {
  props: {
    invoice: Object
  },
  data () {
    return {
      paymentType: 'card',
      autoPayment: false
    }
  },
  methods: {
    formatServiceName (name) {
      return name.charAt(0).toUpperCase() + name.slice(1)
    }
  },
  computed: {
    invoicePaymentLink () {
      return `/api/superbilling/invoices/pay/${this.invoice._id}?with_subscription=${this.autoPayment ? 'true' : 'false'
        }`
    }
  }
}
</script>

<style>
.pay-invoice-modal {
  height: fit-content;
  max-height: 90vh;
}
</style>

<style scoped>
.services-table {
  display: flex;
  flex-direction: column;
}

.services-table-header {
  border-bottom: 1px solid var(--qrw-border-base-tertiary);
  box-sizing: border-box;
  display: flex;
  padding: 0 12px;
  color: var(--qrw-content-base-tertiary);
  background: var(--qrw-background-base-primary);
}

.services-table-row {
  color: var(--qrw-content-base-primary);
  background: var(--qrw-background-base-primary);
  border-bottom: 1px solid var(--qrw-border-base-tertiary);
  box-sizing: border-box;
  display: flex;
  padding: 0 12px;
}

.services-table-total {
  padding: 16px 24px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  column-gap: 8px;
}

.column-service {
  min-width: 160px;
  width: 160px;
}

.column-period {
  min-width: 240px;
  width: 240px;
}

.column-subscription {
  min-width: 246px;
  width: 246px;
}

.column-sum {
  width: 200px;
  min-width: 200px;
}

.services-table-column {
  padding: 16px 12px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

.pay-modal-actions {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  padding: 24px;
  box-sizing: border-box;
  background: var(--qrw-background-base-secondary);
  border-top: 1px solid var(--qrw-border-base-tertiary);
}

.pay-button-row {
  display: flex;
  justify-content: flex-end;
}

.payment-type-row {
  justify-content: space-between;
  align-items: center;
}

.pay-modal-header {
  align-items: center;
}
</style>